// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VaFhS{position:relative;box-sizing:border-box;display:inline-flex;justify-content:center;align-items:center;font-family:"Lufga-Regular";font-weight:400;box-shadow:0px 4px 24px rgba(40,40,99,.12);border:none}.VaFhS:not([disabled]){cursor:pointer}.VaFhS[disabled]{cursor:default;pointer-events:none}.VaFhS:focus-within{outline:2px solid #6942f8;outline-offset:2px}@supports(-webkit-appearance: none){.VaFhS:focus-within{outline:2px solid transparent;box-shadow:0px 4px 24px rgba(40,40,99,.12),0 0 0 2px #fff,0 0 0 4px #6942f8}}.doaMs{display:inline-block}.sg-focus-disabled .VaFhS:focus-within{outline:0;box-shadow:none}.Gv7gj{border-radius:4px}.BBftv{border-radius:8px}.tlGO0{font-size:var(--font-size-h6, 20px);line-height:var(--line-height-h6, 35px);letter-spacing:.01em;font-family:"Lufga-Regular";font-weight:400;min-inline-size:112px;block-size:48px;padding:8px 16px;gap:12px}.PG4Uc{font-size:var(--font-size-p1, 16px);line-height:var(--line-height-p1, 24px);letter-spacing:.015em;font-family:"Lufga-Regular";font-weight:400;min-inline-size:96px;block-size:40px;padding:8px 12px;gap:12px}.HPhQl{font-size:var(--font-size-p2, 14px);line-height:var(--line-height-p2, 18px);letter-spacing:.02em;font-family:"Lufga-Regular";font-weight:400;min-inline-size:96px;block-size:34px;padding:8px 10px;gap:6px}.PqexW{width:100%}.iFX_9{white-space:nowrap}a.VaFhS{text-decoration:none}.FXMN6{color:var(--button-secondary, #fcfcfd);background:var(--button-primary, #6942f8)}.FXMN6:hover:not([disabled]):not(:active){background:var(--button-primary-dark, #4520cc)}.FXMN6:active{background:var(--button-primary-light, #8768f9)}.FXMN6[disabled]{background:var(--button-disabled, #bfbfd0)}.otpnU,.x5aR0{color:var(--button-primary, #6942f8);background:transparent;border:2px solid var(--button-primary, #6942f8)}.otpnU:visited,.x5aR0:visited{color:var(--button-primary, #6942f8)}.otpnU:hover:not([disabled]):not(:active),.x5aR0:hover:not([disabled]):not(:active){color:var(--button-secondary, #fcfcfd);background:var(--button-primary-dark, #4520cc);border-color:var(--button-primary-dark, #4520cc)}.otpnU:active,.x5aR0:active{color:var(--button-secondary, #fcfcfd);background:var(--button-primary-light, #8768f9);border-color:var(--button-primary-light, #8768f9)}.otpnU[disabled],.x5aR0[disabled]{color:var(--button-disabled-dark, #a9a9c1);border-color:var(--button-disabled-dark, #a9a9c1)}.x5aR0{background:var(--button-secondary, #fcfcfd)}.cSB9U{color:#282863;background:transparent;border:2px solid #282863}.cSB9U:hover:not([disabled]):not(:active){color:#fff;background:#282863}.cSB9U:active{color:#fff;background:#696992;border-color:#696992}.cSB9U[disabled]{color:var(--button-disabled-dark, #a9a9c1);border-color:var(--button-disabled-dark, #a9a9c1)}.V83rI{color:#fcfcfd;background:#e86161}.V83rI:hover:not([disabled]){background:#dd4c4c}.V83rI[disabled]{background:var(--button-disabled, #bfbfd0)}.Yalyy{color:#e86161;background:transparent;border:2px solid #e86161}.Yalyy:hover:not([disabled]){color:var(--button-secondary, #fcfcfd);background:#dd4c4c;border-color:#dd4c4c}.Yalyy[disabled]{color:var(--button-disabled-dark, #a9a9c1);border-color:var(--button-disabled-dark, #a9a9c1)}.nizhI,.ouuee{display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blue45": `#fcfcff`,
	"blue48": `#f5f7fd`,
	"blue50": `#f3f5ff`,
	"blue300": `#dae0ff`,
	"blue500": `#c0caff`,
	"blue600": `#a1aef5`,
	"blue700": `#8296ff`,
	"blue800": `#6176e7`,
	"dark50": `#fcfcfd`,
	"dark70": `#f4f4f7`,
	"dark100": `#eaeaef`,
	"dark120": `#e4e4ec`,
	"dark200": `#d4d4e0`,
	"dark300": `#bfbfd0`,
	"dark400": `#a9a9c1`,
	"dark500": `#9393b1`,
	"dark600": `#7e7ea1`,
	"dark700": `#696992`,
	"dark800": `#535382`,
	"dark900": `#282863`,
	"green45": `#eff6fa`,
	"green50": `#f3fcfa`,
	"green300": `#b6ebdf`,
	"green500": `#86ddca`,
	"green700": `#56d0b5`,
	"green800": `#36b89b`,
	"green900": `#089475`,
	"orange50": `#fdf2dc`,
	"orange300": `#fadea8`,
	"orange500": `#f9d797`,
	"orange700": `#f7ca75`,
	"orange800": `#f5bd52`,
	"orange900": `#dd9306`,
	"purple50": `#e1d9fe`,
	"purple300": `#c3b3fc`,
	"purple500": `#a58efb`,
	"purple700": `#8768f9`,
	"purple800": `#6942f8`,
	"purple900": `#4520cc`,
	"red200": `#fdf0f0`,
	"red300": `#fee3e3`,
	"red500": `#f9d5d5`,
	"red700": `#f3aaaa`,
	"red900": `#eb7272`,
	"red950": `#e86161`,
	"red970": `#dd4c4c`,
	"white": `#fff`,
	"defaultTextStandard": `#282863`,
	"defaultTextSecondary": `#696992`,
	"defaultButtonPrimary": `#6942f8`,
	"buttonPrimary": `var(--button-primary, #6942f8)`,
	"buttonPrimaryDark": `var(--button-primary-dark, #4520cc)`,
	"buttonDisabled": `var(--button-disabled, #bfbfd0)`,
	"buttonDisabledDark": `var(--button-disabled-dark, #a9a9c1)`,
	"defaultButtonDisabled": `#bfbfd0`,
	"defaultStepperCompleted": `#089475`,
	"defaultStepperIncomplete": `#d4d4e0`,
	"defaultButtonSecondary": `#fcfcfd`,
	"defaultBgStandard": `#f3f5ff`,
	"defaultBgLight": `#fff`,
	"sh10": `0px 4px 12px rgba(40,40,99,.06)`,
	"sh20": `0px 4px 16px rgba(40,40,99,.08)`,
	"sh40": `0px 4px 24px rgba(40,40,99,.12)`,
	"sh60": `0px 4px 14px rgba(40,40,99,.24)`,
	"fontFamilyLight": `"Lufga-Regular"`,
	"fontFamilyNormal": `"Lufga-Medium"`,
	"fontFamilyBold": `"Lufga-SemiBold"`,
	"fontSizeH1": `var(--font-size-h1, 48px)`,
	"fontSizeH2": `var(--font-size-h2, 40px)`,
	"fontSizeH3": `var(--font-size-h3, 33px)`,
	"fontSizeH4": `var(--font-size-h4, 28px)`,
	"fontSizeH5": `var(--font-size-h5, 22px)`,
	"fontSizeH6": `var(--font-size-h6, 20px)`,
	"fontSizeP1": `var(--font-size-p1, 16px)`,
	"fontSizeP2": `var(--font-size-p2, 14px)`,
	"fontSizeP3": `var(--font-size-p3, 12px)`,
	"lineHeightH1": `var(--line-height-h1, 64px)`,
	"lineHeightH2": `var(--line-height-h2, 56px)`,
	"lineHeightH3": `var(--line-height-h3, 40px)`,
	"lineHeightH4": `var(--line-height-h4, 40px)`,
	"lineHeightH5": `var(--line-height-h5, 32px)`,
	"lineHeightH6": `var(--line-height-h6, 35px)`,
	"lineHeightP1": `var(--line-height-p1, 24px)`,
	"lineHeightP2": `var(--line-height-p2, 18px)`,
	"lineHeightP3": `var(--line-height-p3, 16px)`,
	"FOCUS_DISABLED_CLASS": `sg-focus-disabled`,
	"root": `VaFhS`,
	"wrapper": `doaMs`,
	"sRoundness": `Gv7gj`,
	"mRoundness": `BBftv`,
	"largeSize": `tlGO0`,
	"mediumSize": `PG4Uc`,
	"smallSize": `HPhQl`,
	"fluid": `PqexW`,
	"noWrap": `iFX_9`,
	"primarySkin": `FXMN6`,
	"primaryOutlineSkin": `otpnU`,
	"primaryOutlineOpaqueSkin": `x5aR0`,
	"darkSecondarySkin": `cSB9U`,
	"dangerSkin": `V83rI`,
	"dangerOutlineSkin": `Yalyy`,
	"prefixIcon": `nizhI`,
	"suffixIcon": `ouuee`
};
export default ___CSS_LOADER_EXPORT___;
